// extracted by mini-css-extract-plugin
export var subtitleText = "account-title-module--subtitle-text--XEaTt";